import { FooterLegalBar } from "./footer";

const SiteFooter = () => {
  const year = new Date().getFullYear();
  return <FooterLegalBar year={year} />;
};

export default SiteFooter;
